import React, { Component } from 'react';

import style from './BackToChapterButton.module.scss';

const BackToChapterButton = ({
  onChapterClose,
  onVideoClose,
  isPlaylistOpen,
  isVideoOpen,
}) => {
  const handleChapterClose = () => {
    if (isPlaylistOpen) {
      onChapterClose();
    } else if (isVideoOpen) {
      onVideoClose();
    }
  };

  return (
    <div
      className={`back-to-chapter ${style.backToChapter}`}
      style={{ pointerEvents: isPlaylistOpen || isVideoOpen ? 'auto' : 'none' }}
      onClick={handleChapterClose}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="24"
        viewBox="0 0 27 24"
        className={style.navArrow}
      >
        <title>Left Arrow</title>
        <polygon points="3.891 10.946 26.267 10.946 26.267 12.592 3.917 12.592 13.92 22.171 12.776 23.267 .755 11.756 12.776 .245 13.92 1.341" />
        <circle cx="50%" cy="50%" r="50%" />
      </svg>
      Back to the Chapter
    </div>
  );
};

export default BackToChapterButton;



// WEBPACK FOOTER //
// ./src/components/chapter/BackToChapterButton.js